import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';
import classNames from 'classnames';

import * as styles from './styles.css';

export const RadioButton = ({
  name,
  value,
  label,
  checked,
  disabled,
  onChange,
}: {
  name: string;
  value: string;
  label: string;
  checked: boolean;
  disabled: boolean;
  onChange(): void;
}) => (
  <label
    htmlFor={value}
    className={classNames(styles['button'], checked && styles['checked'], disabled && styles['disabled'])}
  >
    <input
      checked={checked}
      disabled={disabled}
      type="radio"
      id={value}
      name={name}
      value={value}
      onChange={onChange}
    />
    <InlineText2>{label}</InlineText2>
  </label>
);
